import { groupBy, keyBy, mapValues } from 'lodash-es';
import { MapActivity, MapWorkstream } from '../../ioStore';
import { calculateMaxWindowedActivitiesSumForTemplate } from './calculateMaxWindowedActivitiesSumForTemplate';

const MIN_WINDOW = 5;
const WINDOW_RATIO = 0.1;
const MIN_LANES_IN_WORKSTREAM = 2;

/**
 * Calculates the ideal number of Activity Lanes per Workstream
 * based on the Activities distribution throughout the project.
 *
 * @returns A dictionary of the ideal max number of Activity Lanes per Workstream
 */
export function calculateIdealMaxLanesPerWorkstreamInTemplate(
  workstreams: MapWorkstream[],
  activitiesInWorkstream: (wsId: string) => MapActivity[],
  projectDuration: number,
  maxLanesPerWorkstream: number,
): Record<string, number> {
  const workstreamsById = keyBy(workstreams, 'id');
  const slidingWindow = Math.trunc(
    Math.max(projectDuration * WINDOW_RATIO, MIN_WINDOW),
  );

  /**
   * Calculates the ideal number of Activity Lanes for Workstream
   * in Template mode.
   */
  const getIdealMaxLanesForTemplateWorkstream = (workstream: MapWorkstream) => {
    const activities = activitiesInWorkstream(workstream.id);
    const activitiesPerPosition = groupBy<MapActivity>(
      activities,
      (activity) => activity.originalPosition,
    );

    const templateDuration = projectDuration;

    /**
     * Calculate the ideal number of lanes required for the Workstream
     */
    const maxLanesRequiredForWorkstream =
      calculateMaxWindowedActivitiesSumForTemplate(
        templateDuration,
        activitiesPerPosition,
        slidingWindow,
      );

    return Math.max(
      Math.min(maxLanesRequiredForWorkstream, maxLanesPerWorkstream),
      MIN_LANES_IN_WORKSTREAM,
    );
  };

  const idealMaxLanesPerWorkstream = mapValues(
    workstreamsById,
    getIdealMaxLanesForTemplateWorkstream,
  );

  return idealMaxLanesPerWorkstream;
}
